import React from "react";
import ServiceFromSkyline from "../../Services/Components/ServiceFromSkyline";
import FriendlyEngagementModel from "../../Services/Components/FriendlyEngagementModel";
import AboutSkylineInfosys from "../../Services/Components/AboutSkylineInfosys";
import MajorClient from "../../Home/Components/MajorClient";
import Testimonials from "../../Home/Components/Testimonials";
import Banner from "../../../Component/Banner";
import DevelopmentInfo from "../../Services/Components/DevelopmentInfo";
import BannerImage from "../../../Images/Technology/ReactNative/react-native-service.webp";
import BannerImage1 from "../../../Images/Technology/ReactNative/react-native-banner.webp";
import TechnologiesPlatforms from "../../Services/Components/TechnologiesPlatforms";
import {
  ProjectPlanData,
  Technologies,
  technologyFeatureData,
} from "../../../data";
import TechnologiesFeatures from "../Components/TechnologiesFeatures";
import "../Technology.css";
import AboutDevelopment from "../../Services/Components/AboutDevelopment";
import { Helmet } from "react-helmet";
import CommonBg from "../../../Images/Common/CommonBg.webp";

const ReactNativeService = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Top-Tier React Native Development Services | Skyline Infosys
        </title>
        <meta
          name="description"
          content="
Skyline Infosys offers efficient React Native app development, perfect for cost-effective solutions. Partner with us for your app success"
        />
        <meta name="keywords" content="React Native development services" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div className="service technology">
        <div className="home ">
          <Banner
            backGroundImg={CommonBg}
            heading="React Native App Development"
            content="Looking to build a cost-effective and high-performing mobile app? React Native is the perfect choice for cross-platform app development. At Skyline Infosys, we provide end-to-end React Native app development services to bring your ideas to life."
            title="Development Company"
            btnText="Consult Skyline"
            subTitle="Explore React Native App Development Company"
          />
        </div>

        <DevelopmentInfo
          heading="React Native Development"
          title="React Native Development Services Across India"
          image={BannerImage}
          content={
            <>
              <p className="my-3">
                As a leading React Native app development company in India, we
                offer a comprehensive range of React Native development services
                to help businesses unlock the potential of cross-platform mobile
                applications. Our team of skilled React Native developers
                specializes in building high-performance, feature-rich, and
                visually captivating apps for both Android and iOS platforms.
              </p>
              <p>
                Our React Native app development services include app design,
                development, testing, deployment, and maintenance. We leverage
                the latest tools and technologies to deliver innovative React
                Native apps that ensure a seamless user experience across
                various devices and platforms.
              </p>
            </>
          }
        />
        <TechnologiesFeatures
          data={technologyFeatureData}
          technology={"flutter"}
          heading="Why Should You Go For React Native App Development ?
"
        />

        <DevelopmentInfo
          heading=""
          title="How Do We Developed React Native App Development?"
          image={BannerImage1}
          order={2}
          content={
            <>
            <p className="my-3">
              As a leading React Native app development company, we follow a streamlined process to create high-quality, feature-rich React Native apps that align with our clients' business goals and exceed their expectations.
            </p>
            <p>
              Our team of expert React Native developers leverages the JavaScript programming language and React framework to build apps. By utilizing React Native's extensive library of pre-built components and tools, we deliver high-performance, secure, and scalable mobile applications for both Android and iOS platforms.
            </p>
          </>
          
          }
        />

        <TechnologiesPlatforms
          heading="Technologies & Platforms We work With"
          data={Technologies}
          technologies={[
            "Frontend",
            "Framework",
            "Database",
            "Testing",
            "Project Management",
          ]}
          serviceName="Mobile Development"
        />
        <ServiceFromSkyline />
        <hr className="mb-0" />
        <AboutDevelopment
          heading="How we work "
          content="vuejs"
          data={ProjectPlanData}
        />
        <hr className="mb-0" />
        <FriendlyEngagementModel />
        <AboutSkylineInfosys />
        <MajorClient />
        <Testimonials />
      </div>
    </>
  );
};

export default ReactNativeService;
